module.exports = __webpack_public_path__ + "img/romantik-guide5.7f8db8bf.jpg";